export default "__VITE_ASSET__CVLmJRF8__"